var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sourceSTNreport"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.viewSTNmodal = false
      }
    },
    model: {
      value: (_vm.viewSTNmodal),
      callback: function($$v) {
        _vm.viewSTNmodal = $$v
      },
      expression: "viewSTNmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSTNModel),
      expression: "showSTNModel"
    }],
    staticClass: "col-12 margintop"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0px !important"
    },
    attrs: {
      "id": "STNContent"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-headerfrm displayprint"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.stockTransferDetails')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeviewSTNmodal
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "forprint",
    staticStyle: {
      "background-color": "#e4dddd",
      "text-align": "center",
      "border": "1px solid #ccc",
      "line-height": "30px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('stockTransfer.stockTransferDetails')) + "\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered mytable12",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('stockTransfer.stnID')) + ":  " + _vm._s(_vm.stnidDetails))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('stockTransfer.status')) + ": " + _vm._s(_vm.Details.status))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFC')) + ": ")]), _vm._v(" " + _vm._s(_vm.sourceWarehouseDetails.warehousename))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sourceWarehouseDetails.warehouseaddress) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.state')) + "  " + _vm._s(_vm.sourceWarehouseDetails.warehousestate) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sourceWarehouseDetails.warehousecity) + " - " + _vm._s(_vm.sourceWarehouseDetails.warehousepincode) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.contactPerson')) + "  " + _vm._s(_vm.sourceWarehouseDetails.contactpersonname) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.contactNo')) + "  " + _vm._s(_vm.sourceWarehouseDetails.contactno) + " ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFC')) + " :")]), _vm._v("  " + _vm._s(_vm.destinationWarehouseDetails.warehousename))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.destinationWarehouseDetails.warehouseaddress) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.state')) + "  " + _vm._s(_vm.destinationWarehouseDetails.warehousestate) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.destinationWarehouseDetails.warehousecity) + " - " + _vm._s(_vm.destinationWarehouseDetails.warehousepincode) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.contactPerson')) + "  " + _vm._s(_vm.destinationWarehouseDetails.contactpersonname) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.contactNo')) + "  " + _vm._s(_vm.destinationWarehouseDetails.contactno) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.totalSku')) + " : " + _vm._s(_vm.Details.nooflines) + " ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.totalQty')) + " : " + _vm._s(_vm.Details.totalqty)), _c('br')])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.transporter')) + ": " + _vm._s(_vm.Details.transportername)), _c('br')])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.createdBy')) + ": " + _vm._s(_vm.Details.createdby)), _c('br')])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', {
    staticClass: "fil"
  }, [_vm._v(" " + _vm._s(_vm.$t('stockTransfer.createdDate')) + " : " + _vm._s(_vm._f("moment")(_vm.Details.createddate))), _c('br')])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.requiredDate')) + " : " + _vm._s(_vm._f("moment")(_vm.Details.requireddate))), _c('br')])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {}, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "12px",
      "margin-left": "16px"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered mytable12"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticStyle: {
      "display": "table-cell",
      "text-align": "left",
      "height": "40px",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineNo')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productID')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productName')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productUom')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productMrp')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.requestedQty')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.allocatedQty')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.unallocatedQty')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "110px",
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineStatus')) + " ")])])]), _vm._v(" "), _vm._l((_vm.STNDetails), function(data, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.uom))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.allocatedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.unallocatedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.linestatus))])])])
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('div', {
    staticClass: "downarr"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.totalValue')))])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.twoDecimal(_vm.STNsubtotal)))])])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 totalval"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('stockTransfer.acknowledgementMsg')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 totalval makebold"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.date')))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "makebold"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.yourName')))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "makebold"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.yourDesignation')))])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary glass printbtn",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-left": "19px"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.loading ? _vm.loadingText : 'Print')
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.print')))])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.type')))]), _vm._v(" "), _c('b-input-group', [_c('b-form-fieldset', {
    attrs: {
      "label": "",
      "label-cols": 4,
      "horizontal": false
    }
  }, [_c('b-form-radio', {
    attrs: {
      "plain": true,
      "options": [{
          text: _vm.$t('stockTransfer.goodsInward'),
          value: '1'
        },
        {
          text: _vm.$t('stockTransfer.goodsOutward'),
          value: '2'
        }
      ],
      "value": "searchType"
    },
    model: {
      value: (_vm.searchType),
      callback: function($$v) {
        _vm.searchType = $$v
      },
      expression: "searchType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.stnID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('stockTransfer.stnPlaceholderId')
    },
    model: {
      value: (_vm.searchSTNID),
      callback: function($$v) {
        _vm.searchSTNID = $$v
      },
      expression: "searchSTNID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.status')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('not_in:Choose'),
      expression: "'not_in:Choose'"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.selectPlaceholderSTN')))]), _vm._v(" "), _vm._l((_vm.liststatusData), function(status_obj) {
    return _c('option', {
      domProps: {
        "value": status_obj.status
      }
    }, [_vm._v(_vm._s(status_obj.status))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.creationDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "editable": false,
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.searchcreationdate),
      callback: function($$v) {
        _vm.searchcreationdate = $$v
      },
      expression: "searchcreationdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "540px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getSTNData
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(_vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" \n                "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.$t('common.resetBtn')) + " ")])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('stockTransfer.stnList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.stnID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.status')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.clientName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFC')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFC')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.totalQTY')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.noOfLine')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.transporter')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.requiredDate')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.createdDate')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.createdBy')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.table.action')))])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSTNData), function(data, index) {
    return (_vm.listSTNData) ? _c('tr', [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.stnid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sourcewarehousename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.destinationwarehousename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.nooflines))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.transportername))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.requireddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          _vm.getSTNRowDetails(data.stnid, data.clientid)
        }
      }
    })])]) : _c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "scope": "row",
        "colspan": "12"
      }
    }, [_vm._v(_vm._s(_vm.$t('stockTransfer.noDataAvailable')))])])
  })], 2)]), _c('br'), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.checkStockmodel = false
      }
    },
    model: {
      value: (_vm.checkStockmodel),
      callback: function($$v) {
        _vm.checkStockmodel = $$v
      },
      expression: "checkStockmodel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.viewSTN')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hidecheckStockmodel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.stnID')) + ":")]), _vm._v(_vm._s(_vm.stnidDetails))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('common.status')) + ":")]), _vm._v(_vm._s(_vm.Details.status))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFC')) + ":")]), _vm._v(_vm._s(_vm.Details.sourcewarehouse))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFC')) + ":")]), _vm._v(_vm._s(_vm.Details.destinationname))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('common.totalQTY')) + ":")]), _vm._v(_vm._s(_vm.Details.totalqty))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.transporter')))]), _vm._v(_vm._s(_vm.Details.transportername))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('common.createdBy')) + ":")]), _vm._v(_vm._s(_vm.Details.createdby))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.requiredDate')) + ":")]), _vm._v(_vm._s(_vm.Details.requireddate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('common.createdDate')) + ":")]), _vm._v(_vm._s(_vm.Details.createddate))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineNo')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productID')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.ProductDesc')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productUom')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productMrp')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.requestedQty')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.allocatedQty')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.unallocatedQty')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineStatus')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.STNDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.productdescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.uom))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.requestedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.allocatedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.unallocatedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.linestatus))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  })])])]), _vm._v(" "), (_vm.pageCount > 0) ? _c('b-pagination', {
    staticClass: "mt-4",
    attrs: {
      "total-rows": _vm.pageCount * _vm.pageLimit,
      "per-page": _vm.pageLimit,
      "aria-controls": "my-table",
      "first-text": "⏮",
      "prev-text": "⏪",
      "next-text": "⏩",
      "last-text": "⏭"
    },
    on: {
      "input": function($event) {
        _vm.getPaginationData(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f7e926c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7e926c6","hasScoped":true}!./src/views/components/sourceSTNreport/sourceSTNreport.component.html
// module id = 860
// module chunks = 0